import styled from 'styled-components'

export const CatalogItemTagLabelStyled = styled.span`
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  font-weight: ${(props) => props.theme.fontWeights.normal};
  line-height: ${(props) => props.theme.typography.pxToRem(16)};
`
